import { Link } from "react-router-dom";
import type { Drama } from "@/types/content";

interface DramaCardProps {
  drama: Drama;
  variant?: "poster" | "row";
}

export default function DramaCard({ drama, variant = "poster" }: DramaCardProps) {
  if (variant === "row") {
    return (
      <Link
        to={`/detail/${drama.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300"
      >
        <div className="relative w-28 sm:w-32 shrink-0 overflow-hidden rounded-md bg-background-200">
          <div className="w-full aspect-[2/3]">
            <img
              src={drama.cover}
              alt={`${drama.title} 海报`}
              title={`${drama.title} 剧情介绍及演员信息`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>
        <div className="flex-1 min-w-0 py-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">{drama.type}</span>
            <span className="rounded bg-accent-100 px-2 py-0.5 text-xs text-accent-900">评分 {drama.rating}</span>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
            {drama.title}
          </h3>
          <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2 leading-relaxed">{drama.synopsis}</p>
          <div className="mt-2.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span>{drama.year}</span>
            <span className="w-1 h-1 rounded-full bg-foreground-300" />
            <span>{drama.region}</span>
            <span className="w-1 h-1 rounded-full bg-foreground-300" />
            <span className="truncate">{drama.genres.join(" · ")}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={drama.cover}
          alt={`${drama.title} 海报`}
          title={`${drama.title} 剧情介绍及演员信息`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded bg-foreground-950/70 px-2 py-0.5 text-xs text-white backdrop-blur-sm">
          {drama.type}
        </span>
        <span className="absolute top-2 right-2 rounded bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {drama.rating}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="font-heading text-base font-semibold text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
          {drama.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2 leading-relaxed">{drama.synopsis}</p>
        <div className="mt-auto pt-3 flex items-center gap-2 text-xs text-foreground-500">
          <span>{drama.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300" />
          <span className="truncate">{drama.genres[0]}</span>
        </div>
      </div>
    </Link>
  );
}